import React, { useEffect, useState } from 'react';
// import '../Main.css';
import axios from "axios";
import Button from '@mui/material/Button';

import './Button.css';
import Header from './Farbe';
import Logo from './Logo';
import NutriTable from './Nutri';
import Home from './Home';



function Buttons() {

    const [meals, setMeals] = useState();
    const [categories, setCategories] = useState("");
    const [bezeichnung, setBezeichnung] = useState("");
    const [nutri, setNutri] = useState("");
    const [first, setFirst] = useState(null);
    const [second, setSecond] = useState(null);


    const [showResult, setShowResult] = useState(null);
    const [zutaten, setZutaten] = useState(null)
    const [nutriData, setNutriData] = useState(null);

    const [zusatzstoffe, setZusatzstoffe] = useState(null);

    const [bild, setBild] = useState(null);
    // const [intake, setIntake] = useState(null);

    const [farbe1, setFarbe1] = useState("");
    const [farbe2, setFarbe2] = useState("");
    const [farbe3, setFarbe3] = useState("");




    useEffect(() => {
        let config = {
            method: "get",
            url: "https://intranet-backend.procuratio.com/tablet/lmiv.php",


            headers: {
                Accept: "application/json"
            }
        };

        axios(config)
            .then(function (response) {
                setMeals(response.data);
                setBild(response.data.bild);
            })
            .catch(function (error) {
                console.log(error);
            });
    }, []);

    useEffect(() => { console.log(bild) }, [bild])



    useEffect(() => {
        meals &&
            setCategories(
                Array.from(new Set(meals.map((element) => element.kategorie))).sort()
            );
    }, [meals]);

    useEffect(() => {
        bezeichnung &&
            console.log("CAT",bezeichnung)
    }, [bezeichnung]);



    // https://login.solufind.de/funktionen/$%7Bvariable%7D.json?code


    useEffect(() => {

        axios.get(`https://login.solufind.de/funktionen/farben.json`)

            .then((response) => {

                setFarbe1(response.data[0].farbe1);
                setFarbe2(response.data[0].farbe2);
                setFarbe3(response.data[0].farbe3);


            })
            .catch(function (error) {
                console.log(error);
            });
    }, [])

    useEffect(() => { console.log(farbe1) }, [farbe1]);
    useEffect(() => { console.log(farbe2) }, [farbe2]);
    useEffect(() => { console.log(farbe3) }, [farbe3]);

    function mealCategories(e) {


        console.log("mealcategories() -> e", e)
        setFirst(e)
        const cat = meals.filter((c) => c.kategorie === e)
        console.log("mealcategories() -> cat", cat)

        setBezeichnung(cat.map((element) => element.bezeichnung));
        setNutri(null)


    }

    function Bezeichnung(e) {

        setNutri(meals.filter((b) => b.bezeichnung === e))

    }

    function getNutrition(e) {


        setSecond(e)

        setBild(null)
        setZutaten(null)
        setZusatzstoffe(null)
        // setIntake(null);

        console.log("getNutrition() -> e", e)
        setNutri(meals.filter((b) => b.bezeichnung === e))

        let tempData = meals.filter((b) => b.bezeichnung === e)
        setNutriData(tempData[0]);
        console.log('nutridata',nutriData)




    }

    function showNutrition() {



        return Object.entries(nutri[0]).map(([k, v, i]) => {

            return (
                <div key={i}>{` ${k} : ${v}`}</div>
            )

        })
    }

    return (



        <div style={{ 'color': farbe2, 'backgroundColor': farbe3 }} className="container-fluid">



            <div style={{  'color': farbe2, 'backgroundColor': farbe3 }} id="wrapper_main">

                <Header />
               

                <div id="box-upper">


                </div>



                <div style={{ 'color': farbe2, 'backgroundColor': farbe3, 'height':500  }} id="box-lower">

 <Home/> 


                    <div className="card">

                     

                        <div className='first' style={{ 'color': farbe2, 'backgroundColor': farbe3}} >

                            {categories &&
                                categories.map((element, i) =>
                                    <div style={{ 'color': farbe2, 'backgroundColor': first == element ? '#236b8b' : farbe1}} key={i} className="button" onClick={() => mealCategories(element)}>{element}



                                    </div>)}



                        </div>

                        <div className="card">

                            <div className='first'>
                                {bezeichnung &&
                                    bezeichnung.map((e, i) => <div style={{ 'color': farbe2, 'backgroundColor': second == e ? '#236b8c' : farbe1 }} key={i} className={bezeichnung === i ? 'selected' : 'button'} onClick={() => getNutrition(e)}>
                                        {e}

                                    </div>)}
                            </div>
                        </div>

                        <div className="card">

                            <div className='first'>
                                {nutri && showNutrition() != null ? <NutriTable nutriData={nutriData} /> : <div  >{ }</div>}

                              



                            </div>


                        </div>

                    </div>
                </div>
            </div>
        </div>
    )

}

export default Buttons;



